// Removed import from @shared/documents
import React from 'react';

import useFetch from '../../hooks/useFetch';
import { type UnitatDocument, UnitatsContext } from '../../hooks/useUnitats';

interface UnitatsProviderProps {
	children: React.ReactNode;
}

export const UnitatsProvider: React.FC<UnitatsProviderProps> = ({
	children,
}) => {
	const {
		data: unitats,
		isLoading: isFetchingUnitats,
		error: fetchUnitatsError,
	} = useFetch<UnitatDocument[]>({
		queryKey: ['unitats'],
		url: '/api/unitats',
		// Unitat data only changes when an admin modifies it — no UI triggers invalidation
		queryOptions: { staleTime: 1000 * 60 * 60 }, // 1 hour
	});

	return (
		<UnitatsContext.Provider
			value={{
				unitats: unitats,
				isFetchingUnitats,
				fetchUnitatsError,
			}}
		>
			{children}
		</UnitatsContext.Provider>
	);
};
